<template>
  <main>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    />
    <div class="card_body">
      <div class="card_wrap h-100">
        <div class="d-flex justify-content-end">
          <div class="blockRight w-100">
            <h5 class="title font-weight-bold mb-4">
              タスクタイプ
            </h5>
            <small class="wrap-text">ステップに沿って業務に合わせた設定を行ってください。複数登録することができます。</small>
            <small class="wrap-note" :class="{ 'warning-note': isEnabledTaskTypeWarning }">有効なタスクタイプは最低1つ必要です。</small>
            <div>
              <div class="sortingTable">
                <task-type-setting-table
                  v-if="datasTSort"
                  :tableData="datasTSort"
                  :objectDefaultData="objectDefaultData"
                  :sort-type="'sorting'"
                  v-on:on-delete="onDelete"
                  v-on:on-update-sort="onUpdateSort"
                  v-on:on-insertUpdate="onInsertUpdate"
                  ref="tSort-sorting"
                  :pRejectChuteNo="rejectChuteNo"
                  :showManualSortSetting="showManualSortSetting"
                  :enableMultiSortSetting="enableMultiSortSetting"
                />
                <h4 v-else class="title border-top border-bottom">ご利用のご相談はこちら</h4>
              </div>
              <!-- <br />
              <br />
              <h5 id="item-1-2" class="title pl-3">
                3D Sortで商品仕分け
              </h5>
              <div class="table3dSort">
                <task-type-setting-table
                  v-if="datas3DSort.length > 0"
                  :tableData="datas3DSort"
                  :objectDefaultData="objectDefaultData"
                  :sort-type="'3d'"
                  v-on:on-delete="onDelete"
                  v-on:on-update-sort="onUpdateSort"
                  v-on:on-insertUpdate="onInsertUpdate"
                  ref="3D-sorting"
                />
                <h4 v-else class="title border-top border-bottom">ご利用のご相談はこちら</h4>
              </div>
              <br />
              <br />
              <h5 id="item-1-3" class="title pl-3">
                t-Sortで商品ピッキング
              </h5>
              <div class="tablePickingSort">
                <task-type-setting-table
                  v-if="datasPickingSort.length > 0"
                  :tableData="datasPickingSort"
                  :objectDefaultData="objectDefaultData"
                  :sort-type="'picking'"
                  v-on:on-delete="onDelete"
                  v-on:on-update-sort="onUpdateSort"
                  v-on:on-insertUpdate="onInsertUpdate"
                  ref="picking-sorting"
                />
                <h4 v-else class="title border-top border-bottom">ご利用のご相談はこちら</h4>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center">
        <img class="py-3" src="../../assets/images/setting-wizard/task_detail_setting.svg">
      </div>
      <div class="card_wrap auto">
          <div class="blockRight">
            <h5 class="title font-weight-bold">
              データの利用有無
            </h5>
            <div class="check-data-used">
              <!-- item -->
              <div v-if="hasOrderSortUseCase" class="item">
                <h2 class="title">商品マスタ</h2>
                <p>
                  商品ごとに詳細な設定をしたい時に利用します。<br>
                  商品番号やスキャンコードを参照してマスタに登録した情報を利用できます。
                </p>
                <div
                  :class="[
                    { isActiveChbx: request.mstSetting.mstItemUse == 1 },
                    'boxCheckBox checkbox-header auto'
                  ]"
                >
                  <label class="custom_checkbox">
                    <input
                      @click="handleShowModalConfirm($event, '商品', 'item',request.mstSetting.mstItemUse, request.mstSetting.uploadItemDataExistenceCheck)"
                      type="checkbox"
                      style="position: relative"
                      :true-value="1"
                      :false-value="0"
                      v-model="request.mstSetting.mstItemUse"
                    />
                    <span class="label_name text-nowrap">利用する</span>
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
              <!-- item -->
              <div class="item">
                <h2 class="title">仕分けマスタ</h2>
                <p>
                  シュート先を指定したい時に利用します。<br />
                  有効なタスクタイプの設定で「方面別仕分け（作業指示なし）」を選択している場合は必須です。
                </p>
                <div
                  :class="[
                    { isActiveChbx: request.mstSetting.mstSortingUse == 1, disabled: sortingRequired === 1 },
                    'boxCheckBox checkbox-header auto'
                  ]"
                >
                  <label class="custom_checkbox">
                    <input
                      type="checkbox"
                      style="position: relative"
                      :true-value="1"
                      :false-value="0"
                      :disabled="sortingRequired === 1"
                      v-model="request.mstSetting.mstSortingUse"
                    />
                    <span class="label_name text-nowrap">利用する</span>
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
              <!-- item -->
              <div v-if="hasOrderSortUseCase" class="item">
                <h2 class="title">店舗マスタ</h2>
                <p>
                  店舗ごとに詳細な設定をしたい時に利用します。<br>
                  店舗番号を参照してマスタに登録した情報を利用できます。
                </p>
                <div
                  :class="[
                    { isActiveChbx: request.mstSetting.mstShopUse == 1 },
                    'boxCheckBox checkbox-header auto'
                  ]"
                >
                  <label class="custom_checkbox">
                    <input
                      @click="handleShowModalConfirm($event, '店舗', 'shop', request.mstSetting.mstShopUse, request.mstSetting.uploadShopDataExistenceCheck)"
                      type="checkbox"
                      style="position: relative"
                      :true-value="1"
                      :false-value="0"
                      v-model="request.mstSetting.mstShopUse"
                    />
                    <span class="label_name text-nowrap">利用する</span>
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
              <!-- item -->
              <div class="item">
                <h2 class="title">CSV実績データ</h2>
                <p>
                  作業後に実績を残したい時に利用します。
                </p>
                <div
                  :class="[
                    { isActiveChbx: request.mstSetting.csvResultsUse == 1 },
                    'boxCheckBox checkbox-header auto'
                  ]"
                >
                  <label class="custom_checkbox">
                    <input
                      type="checkbox"
                      style="position: relative"
                      :true-value="1"
                      :false-value="0"
                      v-model="request.mstSetting.csvResultsUse"
                    />
                    <span class="label_name text-nowrap">利用する</span>
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
      </div>
      <div v-if="hasOrderSortUseCase" class="d-flex justify-content-center">
        <img class="py-3" src="../../assets/images/setting-wizard/task_detail_setting_2.svg">
      </div>
      <div v-if="hasOrderSortUseCase" class="card_wrap auto">
        <div class="blockRight">
          <h5 class="title font-weight-bold mb-4">
            タスク明細作成時の厳密性
          </h5>
          <p class="description">
            作業指示データのアップロード時に「マスタに該当データが存在するか確認」の有無を設定できます。<br>
            確認して該当データがない場合は情報を取り込まずにエラー表示します。
          </p>
          <div class="d-flex strict-upload mt-5">
            <div class="strict-upload__left">
              <img src="../../assets/images/setting-wizard/strict.svg">
            </div>
            <div class="strict-upload__right w-100">
              <div class="mater-less-mode">
                <div class="mater-less-mode__checkbox">
                  <label class="label-bold">商品マスタ</label>
                  <span class="required">必須</span>
                </div>
                <div class="form-group">
                  <div>
                    <span class="d-flex align-item-center flex-row boxRadio">
                      <div :class="[{isActiveRadio: request.mstSetting.uploadItemDataExistenceCheck === UPLOAD_ITEM_DATA_EXISTENCE_DO_NOT_CHECK}]">
                        <input
                          type="radio"
                          :checked="request.mstSetting.uploadItemDataExistenceCheck === UPLOAD_ITEM_DATA_EXISTENCE_DO_NOT_CHECK"
                          name="uploadItemDataExistenceCheck"
                          v-model="request.mstSetting.uploadItemDataExistenceCheck"
                          :value="UPLOAD_ITEM_DATA_EXISTENCE_DO_NOT_CHECK"
                          id="uploadItemDataExistenceCheckTrue"
                        />
                        <label for="uploadItemDataExistenceCheckTrue">エラーチェックしない</label>
                      </div>
                      <div :class="[{isActiveRadio: request.mstSetting.uploadItemDataExistenceCheck === UPLOAD_ITEM_DATA_EXISTENCE_CHECK,
                      'disabled': request.mstSetting.mstItemUse == USE_DATA_OFF}, 'custom-boxRadio']">
                        <input
                          type="radio"
                          :checked="request.mstSetting.uploadItemDataExistenceCheck === UPLOAD_ITEM_DATA_EXISTENCE_CHECK"
                          :disabled="request.mstSetting.mstItemUse == USE_DATA_OFF"
                          name="uploadItemDataExistenceCheck"
                          v-model="request.mstSetting.uploadItemDataExistenceCheck"
                          :value="UPLOAD_ITEM_DATA_EXISTENCE_CHECK"
                          id="uploadItemDataExistenceCheckFalse"
                        />
                        <label for="uploadItemDataExistenceCheckFalse">する</label>
                      </div>
                    </span>
                  </div>
                </div>
              </div>
              <div class="mater-less-mode">
                <div class="mater-less-mode__checkbox">
                  <label class="label-bold">店舗マスタ</label>
                  <span class="required">必須</span>
                </div>
                <div class="form-group">
                  <div>
                    <span class="d-flex align-item-center flex-row boxRadio">
                      <div :class="[{isActiveRadio: request.mstSetting.uploadShopDataExistenceCheck === UPLOAD_SHOP_DATA_EXISTENCE_DO_NOT_CHECK}]">
                        <input
                          type="radio"
                          :checked="request.mstSetting.uploadShopDataExistenceCheck === UPLOAD_SHOP_DATA_EXISTENCE_DO_NOT_CHECK"
                          name="uploadShopDataExistenceCheck"
                          v-model="request.mstSetting.uploadShopDataExistenceCheck"
                          :value="UPLOAD_SHOP_DATA_EXISTENCE_DO_NOT_CHECK"
                          id="uploadShopDataExistenceCheckTrue"
                        />
                        <label for="uploadShopDataExistenceCheckTrue">エラーチェックしない</label>
                      </div>
                      <div :class="[{isActiveRadio: request.mstSetting.uploadShopDataExistenceCheck === UPLOAD_SHOP_DATA_EXISTENCE_CHECK,
                      'disabled': request.mstSetting.mstShopUse == USE_DATA_OFF}, 'custom-boxRadio']">
                        <input
                          type="radio"
                          :checked="request.mstSetting.uploadShopDataExistenceCheck === UPLOAD_SHOP_DATA_EXISTENCE_CHECK"
                          :disabled="request.mstSetting.mstShopUse == USE_DATA_OFF"
                          name="uploadShopDataExistenceCheck"
                          v-model="request.mstSetting.uploadShopDataExistenceCheck"
                          :value="UPLOAD_SHOP_DATA_EXISTENCE_CHECK"
                          id="uploadShopDataExistenceCheckFalse"
                        />
                        <label for="uploadShopDataExistenceCheckFalse">する</label>
                        <span class="radio-custom__checkmark"></span>
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="hasOrderSortUseCase" class="card_wrap auto select-form">
        <div class="blockRight">
          <h5 class="title font-weight-bold">
            タスク明細作成時の登録順
          </h5>
          <p class="description">
            作業指示データとマスタを「タスク明細」に登録する優先度を設定できます。<br>
            「管理番号」や「名称」などの関連情報をマスタで紐づけて管理する項目は、登録する優先度でタスク明細（作業データ）の内容が変わる可能性があります。重複する値がある場合は優先されたデータ元の値を登録します。
          </p>
          <div class="data-reference">
            <div class="d-flex data-reference__item">
              <label class="label-bold">商品番号<span class="required ml-2">必須</span></label>
              <div class="form-group">
                <form-select-component
                  :options="itemDataModeOptions.map(field => field.value)"
                  :customLabel="opt => itemDataModeOptions.find(field => field.value === opt).text"
                  v-model="request.mstSetting.uploadItemDataMode"
                />
              </div>
            </div>
            <div class="d-flex data-reference__item">
              <label class="label-bold">店舗番号<span class="required ml-2">必須</span></label>
              <div class="form-group">
                <form-select-component
                  :options="shopDataModeOptions.map(field => field.value)"
                  :customLabel="opt => shopDataModeOptions.find(field => field.value === opt).text"
                  v-model="request.mstSetting.uploadShopDataMode"
                />
              </div>
            </div>
          </div>
          <div class="data-reference-example">
            <div class="img-show" @click="handleShowDataReferenceImg">
              <span class="material-icons help-icon">help_outline</span>
              <span>各パターンの登録データ例</span>
              <span class='material-icons drop-icon'>arrow_drop_down</span>
            </div>
          </div>
          <div class="strictness-data-uploading-icon" v-if="isShowDataReferenceImg">
            <img src="../../assets/images/strictness_data_uploading.svg">
          </div>
        </div>
      </div>
      <!-- item order-number-scan-->
      <div v-if="hasOrderSortUseCase" class="card_wrap auto">
        <div class="order-number-scan">
          <div class="blockRight">
            <h5 class="title font-weight-bold mb-4">
              伝票スキャン
            </h5>
            <div class="d-flex fustify-content-center">
              <div class="order-number-scan__img mr-4">
                <img src="../../assets/images/type-setting/slip_scan.svg">
              </div>
              <div class="d-flex flex-column justify-content-center order-number-scan__content">
                <div>
                  <p>同梱する注文書などの「伝票」を商品と同様にスキャンで管理することができます。<br>
                  伝票をスキャンして管理する場合には「作業指示データ」に必須のマッピング項目が増えます。必ずご確認ください。</p>
                </div>
                <div>
                  <div class="form-group">
                    <div>
                      <span class="d-flex align-item-center flex-row boxRadio">
                        <label><span class="required mr-4">必須</span></label>
                        <div :class="[{isActiveRadio: request.mstSetting.orderNumberScanUse === 0}]">
                          <input
                            type="radio"
                            :checked="request.mstSetting.orderNumberScanUse === 0"
                            name="orderNumberScanUse"
                            v-model="request.mstSetting.orderNumberScanUse"
                            v-bind:value="0"
                            id="order-number-scan-on"
                          />
                          <label for="order-number-scan-on">伝票をスキャンしない</label>
                        </div>
                        <div :class="[{isActiveRadio: request.mstSetting.orderNumberScanUse === 1}]">
                          <input
                            type="radio"
                            :checked="request.mstSetting.orderNumberScanUse === 1"
                            name="orderNumberScanUse"
                            v-model="request.mstSetting.orderNumberScanUse"
                            v-bind:value="1"
                            id="order-number-scan-off"
                          />
                          <label for="order-number-scan-off">伝票をスキャンする</label>
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- item -->
      <div class="d-flex justify-content-center">
        <img class="py-3" src="../../assets/images/setting-wizard/task_detail_setting_3.svg">
      </div>
      <div class="card_wrap">
        <div class="blockRight">
          <h5 class="title font-weight-bold">
            データフォーマット設定
          </h5>
          <small class="wrap-note">アップロード/ダウンロードファイル（CSV）の設定と、マッピング設定を行ってください。</small>
          <b-row class="lable-radio">
            <b-col class="ml-3 delimiter-label">
              <label
                class="label-bold"
                >区切り文字
                <img
                  v-b-tooltip.hover.top.html="{
                    variant: 'secondary',
                    animation: true
                  }"
                  :title="`${request.mstSetting.wmsName}で使用しているCSVの区切り文字を選択します。`"
                  src="../../assets/images/help_outline_gray_24dp.svg"
                  alt="Question mark"
                  class="question_mark"
                />
                <span class="required">必須</span>
              </label>
            </b-col>
            <b-col cols="9">
              <div class="form-group">
                <div>
                  <span class="d-flex align-item-center flex-row boxRadio">
                    <div :class="[{isActiveRadio: delimiterFormat === 1}]">
                      <input
                        type="radio"
                        :checked="delimiterFormat === 1"
                        name="delimiterFormat"
                        v-model="delimiterFormat"
                        v-bind:value="1"
                        id="comma"
                      />
                      <label for="comma">カンマ区切り</label>
                    </div>
                    <div :class="[{isActiveRadio: delimiterFormat === 0}]">
                      <input
                        type="radio"
                        :checked="delimiterFormat === 0"
                        name="delimiterFormat"
                        v-model="delimiterFormat"
                        v-bind:value="0"
                        id="tab"
                      />
                      <label for="tab">タブ区切り</label>
                    </div>
                  </span>
                </div>
              </div>
            </b-col>
          </b-row>
          <!-- Prefix file customs -->
          <!-- Upload -->
            <data-format-setting-component
              v-if="uploadSettingFieldList.length"
              ref="uploadDataFormatSetting"
              :settingTitle="`アップロード設定`"
              :csvTypeList="uploadSettingFieldList"
              :startIndex="0"
              @update-item="updateItem"
            />
          <!-- Export -->
            <data-format-setting-component
              v-if="exportSettingFieldList.length"
              ref="exportDataFormatSetting"
              :settingTitle="`ダウンロード設定`"
              :csvTypeList="exportSettingFieldList"
              :startIndex="uploadSettingFieldList.length"
              @update-item="updateItem"
            />
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center mt-3">
      <button class="btn_blue btn_md" @click="settingUpdate()">保存</button>
    </div>
  </main>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import FlashMessage from '../../common/flash-message.component'
import TaskTypeSettingTable from './TaskTypeSettingTable.vue'
import Loading from 'vue-loading-overlay'
import AppConstants from '../../constants/app.constants'
import FormSelectComponent from '../custom-components/FormSelectComponent.vue'
import DataFormatSettingComponent from './DataFormatSettingComponent.vue'
const SORTING_T_SORT = 1
const SORTING_3D_SORT = 2
// const PICKING_T_SORT = 3
// const ORIGINAL_TASK_DATA_OPTION = 0
// const TASK_DATA_PRIORITY_OPTION = 1
// const MASTER_DATA_PRIORITY_OPTION = 2
export default {
  data() {
    return {
      request: {
        mstCsvType: Object,
        mstSetting: Object
      },
      delimiterFormat: 0,
      datasTSort: [],
      datas3DSort: [],
      datasPickingSort: [],
      isLoading: false,
      objectDefaultData: {},
      messageModal: '',
      rejectChuteNo: '',
      itemDataModeOptions: [
        { value: 0, text: '1. 作業指示データのみ使用して登録する' },
        { value: 1, text: '2. 作業指示データを優先して登録する' },
        { value: 2, text: '3. 商品マスタを優先して登録する' }
      ],
      shopDataModeOptions: [
        { value: 0, text: '1. 作業指示データのみ使用して登録する' },
        { value: 1, text: '2. 作業指示データを優先して登録する' },
        { value: 2, text: '3. 店舗マスタを優先して登録する' }
      ],
      sortingRequired: 0,
      exportSettingFieldList: [],
      uploadSettingFieldList: [],
      isShowDataReferenceImg: false,
      USE_DATA_OFF: 0,
      USE_DATA_ON: 1,
      isEnabledTaskTypeWarning: false,
      UPLOAD_ITEM_DATA_EXISTENCE_DO_NOT_CHECK: 0,
      UPLOAD_ITEM_DATA_EXISTENCE_CHECK: 1,
      UPLOAD_SHOP_DATA_EXISTENCE_DO_NOT_CHECK: 0,
      UPLOAD_SHOP_DATA_EXISTENCE_CHECK: 1,
      enableMultiSortSetting: false,
      showManualSortSetting: false
    }
  },
  components: { TaskTypeSettingTable, Loading, FormSelectComponent, DataFormatSettingComponent },
  async created() {
    await this.$_fetchRequest(true)
    await this.$_fetch_rejectChuteNo()
    this.$_fetch_setting()
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('socket', ['messages'])
  },
  watch: {
    async messages(newValue, oldValue) {
      if (newValue.includes(AppConstants.TASK_TYPE_SETTING_SOCKET)) {
        this.setMessages([])
        await this.$_fetchRequest()
        this.checkDataEffectSettingWizard()
      }
    },
    '$store.state.reconnectedFlag': async function(newValue) {
      if (newValue) {
        await this.$_fetchRequest(true)
        await this.$_fetch_rejectChuteNo()
        await this.$_fetch_setting()
        this.checkDataEffectSettingWizard()
      }
    },
    'request.mstSetting.mstItemUse': {
      handler(newVal) {
        this.updateRequiredFlag('item', newVal)
      }
    },
    'request.mstSetting.mstSortingUse': {
      handler(newVal) {
        this.updateRequiredFlag('sorting', newVal)
      }
    },
    'request.mstSetting.mstShopUse': {
      handler(newVal) {
        this.updateRequiredFlag('shop', newVal)
      }
    },
    'request.mstSetting.csvResultsUse': {
      handler(newVal) {
        this.updateRequiredFlag('result', newVal)
      }
    },
    datasTSort(newVal) {
      if (newVal) {
        this.isEnabledTaskTypeWarning = newVal.every(item => item.isEnabled === 0)
      }
    }
  },
  methods: {
    ...mapActions('setting', ['insertSetting']),
    ...mapGetters('setting', ['getSetting']),
    ...mapActions('socket', ['setMessages']),
    ...mapGetters('socket', ['isSocketEnabled']),
    async $_fetchRequest(initDefaultData = false) {
      await this.fetchRequest()
        .then(response => {
          if (!response.data) {
            return
          }
          const listTaskType = response.data.listTaskType
          this.showManualSortSetting = response.data.showManualSortSetting === 'show'
          this.enableMultiSortSetting = response.data.enableMultiSortSetting
          this.filterDatasBySortingType(listTaskType)
          if (initDefaultData) {
            this.setDefaultData(listTaskType)
          } else {
            this.$refs['tSort-sorting'].checkToShowErrorMsgOnEditModal()
          }
        })
        .catch(err => {
          console.log(err)
          FlashMessage.getInstance().parseAndShowErrorMessage(err)
        })
    },
    async $_fetchData() {
      if (!this.isSocketEnabled()) {
        await this.$_fetchRequest()
        this.checkDataEffectSettingWizard()
      }
    },
    async settingUpdate() {
      await this.$_update_setting()
      this.$grobalListener.$emit('getHeaderTitle')
    },
    async $_fetch_rejectChuteNo() {
      const response = await this.getRejectChuteNo()
      this.rejectChuteNo = response.data.rejectChuteNo
    },
    /**
     * 設定データ取得
     */
    async $_fetch_setting() {
      const results = await this.getSetting()
      this.$_arrange_data(results)
    },
    /**
     * 設定データ更新
     */
    async $_update_setting() {
      // アップロード/エクスポートのデータ形式設定が無効な場合は何もしない
      const validUploadSetting = !this.$refs.uploadDataFormatSetting || this.$refs.uploadDataFormatSetting.validateData()
      const validExportSetting = !this.$refs.exportDataFormatSetting || this.$refs.exportDataFormatSetting.validateData()
      if (!validUploadSetting || !validExportSetting) {
        return
      }

      this.isLoading = true
      try {
        // デリミタ値 上書き
        for (var key in this.request.mstCsvType) {
          this.request.mstCsvType[key]['delimiter'] = this.delimiterFormat
        }
        // アップデート処理開始
        const response = await this.$axios.put('/setting', this.request)
        await this.insertSetting(response)
        this.$_arrange_data(response)
        FlashMessage.getInstance().showSuccessMessage('正常に保存できました。')
      } catch (error) {
        this.isLoading = false
        FlashMessage.getInstance().parseAndShowErrorMessage(error)
      }
      this.isLoading = false
    },
    /**
     * レスポンスデータの値代入
     */
    $_arrange_data(response) {
      // 不要オブジェクトの削除
      delete response.data.mstTableManagements
      // デリミタの値を代入
      if (response.data.mstCsvType.length) {
        this.delimiterFormat = response.data.mstCsvType[0]['delimiter']
      }
      // csvOrderの値で並べ替え
      response.data.mstCsvType.sort((a, b) => a.csvOrder - b.csvOrder)
      this.request = response.data

      // エラーステータスをリセットし、アップロード/エクスポート設定フィールドリストセクションを再表示します
      this.resetErrorStatus(this.uploadSettingFieldList, this.$refs.uploadDataFormatSetting)
      this.resetErrorStatus(this.exportSettingFieldList, this.$refs.exportDataFormatSetting)
      this.displayUploadExportSetting()

      this.checkDataEffectSettingWizard()
    },
    /**
     * アップロード/エクスポート設定フィールドリストセクションのエラーステータスをリセットします。
     * @param settingFieldList アップロード/エクスポート設定フィールド一覧
     * @param dataFormatSettingElement 「データ形式設定」要素
     */
    resetErrorStatus(settingFieldList, dataFormatSettingElement) {
      const settingFieldListLength = settingFieldList.length
      if (settingFieldListLength && dataFormatSettingElement) {
        dataFormatSettingElement.prefixErrMsg = Array(settingFieldListLength).fill('')
        dataFormatSettingElement.errorMsgRequiredPrefixCsv = Array(settingFieldListLength).fill('')
      }
    },
    /**
     * データ効果設定ウィザードを確認してください。
     */
    async checkDataEffectSettingWizard() {
      let anyTaskTypeNoWorkInstruction = 0
      let anyTaskTypeWorkInstruction = 0
      this.datasTSort.map(function(data) {
        if (data.isEnabled === 1 && !AppConstants.DEFAULT_TASK_TYPE_LIST.includes(data.taskType)) {
          if (data.workInstruction === 1) {
            anyTaskTypeWorkInstruction = 1
          } else {
            anyTaskTypeNoWorkInstruction = 1
          }
        }
      })

      // sorting
      this.sortingRequired = anyTaskTypeNoWorkInstruction
      if (!this.request.mstSetting.mstSortingUse) {
        this.request.mstSetting.mstSortingUse = anyTaskTypeNoWorkInstruction
      }

      // task
      this.request.mstCsvType.map(function(csvType) {
        if (csvType.csvNo === 'task') {
          csvType.isRequiredMappingFlag = anyTaskTypeWorkInstruction
          csvType.isRequiredDataFlag = anyTaskTypeWorkInstruction
        } else if (csvType.csvNo === 'sorting' && anyTaskTypeNoWorkInstruction === 1) {
          csvType.isRequiredMappingFlag = anyTaskTypeNoWorkInstruction
          csvType.isRequiredDataFlag = anyTaskTypeNoWorkInstruction
        }
      })
    },
    /**
     * モーダル確認の表示の扱い
     * @param {BvEvent} event ボタンのクリックイベント
     * @param {string} masterName マスターネーム。
     * @param {string} modalType アイテムまたはショップのチェックボックスをオンにして、対応するモーダルを表示します
     * @param {number} useData アイテムまたはショップデータ使用フラグを確認する
     * @param {number} masterlessFlag アイテムまたはショップデータのマスターレスフラグを確認する
     */
    handleShowModalConfirm(event, masterName, modalType, useData, masterlessFlag) {
      const el = this.$createElement
      if (!masterlessFlag || !useData) {
        return
      }
      event.preventDefault()
      const contentBody = el('div', {
        domProps: {
          innerHTML: `<span>利用中の「${masterName}マスタ」を利用停止してよろしいですか？</br>利用停止時には「タスク明細作成時の厳密性」のエラーチェックも停止します。</span>`
        }
      })
      this.showModalConfirm(modalType, contentBody)
    },
    /**
     * モーダル確認変更モード
     * @param {string} modalType モーダルタイプ (アイテムまたはショップ)
     * @param {string} contentBody モーダルの内容
     */
    showModalConfirm(modalType, contentBody) {
      const el = this.$createElement
      const okTitle = el('div', {
        domProps: {
          innerHTML: '<span class="ok-title-button">利用停止</span>'
        }
      })
      const cancelTitle = el('div', {
        domProps: {
          innerHTML: '<span class="cancel-title-button">キャンセル</span>'
        }
      })
      this.$bvModal.msgBoxConfirm([contentBody], {
        title: '連動して停止する項目があります',
        okVariant: 'link text-dark text-decoration-none',
        cancelVariant: 'link text-dark text-decoration-none',
        okTitle: [okTitle],
        cancelTitle: [cancelTitle],
        id: 'modal-confirm-data-use',
        footerClass: 'justify-content-around p-1',
        hideHeaderClose: false,
        class: 'modalConfirm',
        centered: true
      })
        .then(isConfirm => {
          if (!isConfirm) {
            return
          }
          if (modalType === 'item') {
            this.request.mstSetting.uploadItemDataExistenceCheck = this.UPLOAD_ITEM_DATA_EXISTENCE_DO_NOT_CHECK
            this.request.mstSetting.mstItemUse = this.USE_DATA_OFF
          } else {
            this.request.mstSetting.uploadShopDataExistenceCheck = this.UPLOAD_SHOP_DATA_EXISTENCE_DO_NOT_CHECK
            this.request.mstSetting.mstShopUse = this.USE_DATA_OFF
          }
        })
        .catch(() => {})
    },
    displayUploadExportSetting() {
      this.uploadSettingFieldList = []
      this.exportSettingFieldList = []
      if (this.isOnlyNoTaskSortUseCase) {
        this.request.mstCsvType = this.request.mstCsvType.filter(csvType => !AppConstants.NO_TASK_SORT_HIDDEN_LIST.includes(csvType.csvNo))
      }
      this.request.mstCsvType.map(csvType => {
        let csvNo = csvType.csvNo
        if (csvNo === 'result' || csvNo.startsWith('ie-')) {
          this.exportSettingFieldList.push(csvType)
        } else {
          this.uploadSettingFieldList.push(csvType)
        }
      })
    },
    handleShowDataReferenceImg() {
      this.isShowDataReferenceImg = !this.isShowDataReferenceImg
    },
    updateItem(item) {
      const index = this.request.mstCsvType.findIndex((i) => i.csvNo === item.csvNo)
      if (index !== -1) {
        this.$set(this.request.mstCsvType, index, item)
      }
    },
    /** =========================
     * リクエストメソッド
     =========================== */
    async fetchRequest() {
      return this.$axios.get('/setting/task-type')
    },
    deleteDataRequest(taskType) {
      return this.$axios.delete('/setting/task-type', {data: { taskType }})
    },
    updateSortRequest(taskTypeList) {
      return this.$axios.put('/setting/task-type', {taskTypeList: taskTypeList})
    },
    insertUpdateRequest(request) {
      return this.$axios.post('/setting/task-type', request)
    },
    async getRejectChuteNo() {
      return this.$axios.get('/setting/get-reject-chute-no')
    },
    async onInsertUpdate(dataRequest, data) {
      if (!data) this.messageModal = ''
      switch (data.typeModal) {
        case 0:
          this.messageModal = '新規登録成功。'
          break
        case 1:
          this.messageModal = '更新成功。'
          break
        default:
          this.messageModal = '複製成功。'
          break
      }
      try {
        this.isLoading = true
        await this.insertUpdateRequest(dataRequest)
        this.isLoading = false
        this.$refs['tSort-sorting'].closeModalTaskType(true)
        this.$root.$emit('bv::hide::modal', data.sortType)
        FlashMessage.getInstance().showSuccessMessage(this.messageModal)
      } catch (error) {
        this.isLoading = false
        this.$refs['tSort-sorting'].closeModalTaskType(false)
        FlashMessage.getInstance().parseAndShowErrorMessage(error)
      }
      await this.$_fetchData()
    },
    async onDelete(taskType, sortingType) {
      let taskTypeList = []
      const indexDeleted = this.getDatasSortingType(sortingType).map(e => e.taskType).indexOf(taskType)
      const datasFiltered = this.getDatasSortingType(sortingType).slice(indexDeleted + 1).filter(el => !AppConstants.DEFAULT_TASK_TYPE_LIST.includes(el.taskType))
      this.isLoading = true
      try {
        await this.deleteDataRequest(taskType)
        if (datasFiltered.length) {
          datasFiltered.forEach(e => taskTypeList.push({taskType: e.taskType, sort: e.sort - 1}))
        }
        if (taskTypeList.length) {
          await this.updateSortRequest(taskTypeList)
        }
        this.isLoading = false
        FlashMessage.getInstance().showSuccessMessage('削除完了。')
      } catch (error) {
        this.isLoading = false
        FlashMessage.getInstance().parseAndShowErrorMessage(error)
      }
      await this.$_fetchData()
    },
    getDatasSortingType(sortingType) {
      switch (sortingType) {
        case SORTING_T_SORT:
          return this.datasTSort
        case SORTING_3D_SORT:
          return this.datas3DSort
        default:
          return this.datasPickingSort
      }
    },
    async onUpdateSort(taskTypeList) {
      this.isLoading = true
      try {
        await this.updateSortRequest(taskTypeList)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        FlashMessage.getInstance().parseAndShowErrorMessage(error)
      }
      this.$_fetchData()
    },
    setDefaultData(datas) {
      if (!datas) return
      const defaultTaskType = this.isOnlyNoTaskSortUseCase ? AppConstants.DEFAULT_NO_TASK_SORT : AppConstants.DEFAULT_ORDER_TASK_SORT
      const foundTaskType = datas.find(el => el.taskType === defaultTaskType)
      if (foundTaskType && Object.keys(foundTaskType).length) {
        this.objectDefaultData = foundTaskType
      }
    },
    filterDatasBySortingType(datas) {
      if (!datas) return
      this.datasTSort = []
      this.datas3DSort = []
      this.datasPickingSort = []
      this.datasTSort = [...datas.filter(el => !AppConstants.DEFAULT_TASK_TYPE_LIST.includes(el.taskType) &&
                                               el.sortingType === AppConstants.WORK_MODE_T_SORT)]
      this.sortList(this.datasTSort)
    },
    sortList(list) {
      if (!list) return
      list.sort((a, b) => a.sort - b.sort)
    },
    updateRequiredFlag(csvNo, dataUseMode) {
      const dataUseModeFlag = parseInt(dataUseMode)
      this.request.mstCsvType.map(function(csvType) {
        if (csvType.csvNo === csvNo) {
          csvType.isRequiredMappingFlag = dataUseModeFlag
          if (csvType.csvNo !== 'result') {
            csvType.isRequiredDataFlag = dataUseModeFlag
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
main {
  height: 100%;
}
.card_body {
  // 45px is height of button and 16px (margin-top)
  height: calc(100% - 45px - 16px);
  overflow: auto;
  .card-title {
    font-weight: 700;
    @include responsive-fs(20);
    color: #25242299;
    padding-top: 10px;
  }
  .card_wrap {
    padding: 32px;
    margin-bottom: 8px;
    height: fit-content !important;
    &.auto {
      height: auto;
    }
    .wrap-text {
      @include responsive-fs(12);
    }
    .wrap-note {
      display: block;
      @include responsive-fs(12);
      margin-bottom: 26px;
    }
    .warning-note {
      color: #B41B3E;
      @include responsive-fs(12);
    }
    .label-bold {
      font-weight: bold;
      color: #252422;
      @include media-breakpoint-default() {
        white-space: nowrap;
      }
    }
  }
}
#scrollspy-nested {
  position: relative;
  height: 100%;
  overflow-y: auto;
  left: 10px;
}
.title {
  @include responsive-fs(20);
  color: #252422;
  margin-bottom: 40px;
}
.description {
  @include responsive-fs(14)
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  background-color: #fff;
  font-weight: 700;
  @include responsive-fs(16);
  color: #252422;
}
.nav-pills .nav-link {
  color: #666563;
  font-weight: 400;
  @include responsive-fs(16);
}
.table3dSort, .tablePickingSort {
  padding-right: 32px;
  padding-top: 16px;
  .title {
    padding: 30px 0;
    color: #4E66A6;
    font-weight: normal;
    @include responsive-fs(12);
    text-align: center;
  }
}
.blockRight {
  padding-left: 40px;
  .lable-radio {
    flex-wrap: nowrap;
    .delimiter-label {
      white-space: nowrap;
      .label-bold {
        display: flex;
        align-items: center;
        .question_mark {
          margin: 0 5px;
        }
      }
    }
  }
}

.checkbox-header {
  width: 84px;
  height: 36px;
  margin: 0;
  padding: 0 8px 0 15px;
  &.auto {
    display: inline-flex;
    width: auto;
  }
  .custom_checkbox {
    display: flex;
    align-items: center;
    .label_name {
      color: #252422;
      @include responsive-fs(18);
      line-height: 18px;
      @include media-breakpoint-default() {
        @include responsive-fs(14);
        line-height: 14px;
      }
    }
    .checkmark {
      width: 18px;
      height: 18px;
      margin-right: 7px;
      top: 50%;
      transform: translateY(-50%);
      &:after {
        left: 5px;
        bottom: 5px;
      }
    }
  }
}

.check-data-used {
  display: flex;
  flex-wrap: wrap;
  .item {
    width: calc(50% - 20px);
    min-height: 177px;
    padding: 16px;
    margin-bottom: 15px;
    border: 1px solid #D6D6D6;
    @include media-breakpoint-default() {
      width: calc(50% - 4px);
      margin-bottom: 8px
    }
    &:nth-child(2n+1) {
      margin-right: 15px;
      @include media-breakpoint-default() {
        margin-right: 8px;
      }
    }
    &:nth-child(3), &:nth-child(4) {
      margin-bottom: 0;
    }
    .title {
      @include responsive-fs(20);
      font-weight: 700;
      margin-bottom: 8px;
    }
    p {
      margin-bottom: 8px;
    }
  }
}
@include set-style-on-visible-sw-menu('.strict-upload') {
  flex-direction: column;
  &__right {
    margin-top: 24px;
  }
};
.strict-upload {
  &__left {
    width: 25%;
    padding-right: 64px;
    flex-shrink: 0;
  }
  &__right {
    display: grid;
    align-items: center;
    .mater-less-mode {
      display: flex;
      &__checkbox {
        padding-right: 100px;
        @include media-breakpoint-default() {
          padding-right: 10px;
          padding-right: 50px;
          padding-left: 10px;
        }
      }
    }
    p {
      @include responsive-fs(12);
      margin-bottom: 24px;
    }
    .row {
      margin-bottom: 8px;
    }
    .note {
      @include responsive-fs(12);
      color: #B41B3E;
    }
  }
  .boxRadio {
    .disabled {
      background: #e9e9e9;
      border-color: #cccccc;
      opacity: 0.5;
      .custom-boxRadio {
        cursor: default;
        background: red;
      }
    }
  }
}
.select-form {
  overflow: unset;
  .data-reference {
    &__item {
      margin-bottom: 40px;
      &:last-child {
        margin-bottom: 0;
      }
      label {
        width: fit-content;
        padding-left: 40px;
        padding-right: 64px;
        margin-bottom: 0;
        display: flex;
        align-items: center;
        flex-shrink: 0;
      }
      .form-group {
        margin-bottom: 0;
        width: 100%;
        .form-control {
          width: 100%;
        }
      }
    }
  }
  .data-reference-example {
    display: flex;
    justify-content: end;
    margin-top: 20px;
    color: #4E66A6;
    @include responsive-fs(12);
    .img-show {
      display: flex;
      align-items: center;
      cursor: pointer;
      .help-icon {
        @include responsive-fs(12);
      }
    }
  }
  .strictness-data-uploading-icon {
    text-align: center;
    img {
      width: 100%;
      max-width: 815px;
    }
  }
}
.boxCheckBox {
  &.disabled {
    background-color: rgba(37, 36, 34, 0.08);
    .custom_checkbox {
      input[type='checkbox']:checked ~ .checkmark,  .checkmark {
        background-color: #252422;
      }
      &:hover {
        .checkmark {
          background-color: #cccccc;
          border-color: #cccccc;
        }
      }
    }
  }
}
/deep/ #modal-confirm-data-use .modal-dialog {
  max-width: 30vw !important;
  .modal-content {
    min-height: fit-content;
    .modal-title {
      @include responsive-fs(20);
    }
    .modal-body {
      @include responsive-fs(16);
    }
    .modal-footer {
      .ok-title-button {
        font-weight: 700;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/task-type-setting/TaskTypeSetting.vue